import { create } from 'zustand'

const ConfirmationState = create<ConfirmationStateInterface>((set) => {
    const ConfirmationInitialState: ConfirmationStateInterface = {
        Title: '',
        Open: false,
        onConfirm: () => {},
        SetState: (payload: ConfirmationStateInterface) => set((state: ConfirmationStateInterface) => ({
            ...state,
            ...payload
        }))
    }

    return ConfirmationInitialState
})

export default ConfirmationState
